/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTeamsQueryResponse,
  GetTeamsQueryParams,
} from "../types/GetTeams.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTeamsQueryKey = (params?: GetTeamsQueryParams) =>
  [{ url: "/teams" }, ...(params ? [params] : [])] as const;

export type GetTeamsQueryKey = ReturnType<typeof getTeamsQueryKey>;

/**
 * @summary Публичный листинг команд с пагинацией и фильтрацией.
 * Возвращает только активные (не архивные, не временные) команды.
 * {@link /teams}
 */
export async function getTeams(
  params?: GetTeamsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTeamsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/teams`, params, ...requestConfig });
  return res;
}

export function getTeamsQueryOptions(
  params?: GetTeamsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTeamsQueryKey(params);
  return queryOptions<
    ResponseConfig<GetTeamsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetTeamsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTeams(params, { ...config, signal: config.signal ?? signal });
    },
  });
}

/**
 * @summary Публичный листинг команд с пагинацией и фильтрацией.
 * Возвращает только активные (не архивные, не временные) команды.
 * {@link /teams}
 */
export function useGetTeams<
  TData = ResponseConfig<GetTeamsQueryResponse>,
  TQueryData = ResponseConfig<GetTeamsQueryResponse>,
  TQueryKey extends QueryKey = GetTeamsQueryKey,
>(
  params?: GetTeamsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTeamsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getTeamsQueryKey(params);

  const query = useQuery(
    {
      ...getTeamsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
